import { useContext } from 'react';
import { TextField, MenuItem } from '@mui/material';

import { SingleTrafficContext } from '../context';

export const ALIAS_OPTIONS = ['clkid', 'x1', 'x2', 'x3', 'x4', 'x5', 'x6', 'x7', 'x8', 'url'];

const HELPER_TEXT =
  "Optional. The url must send the tag (e.g. ?sub1=test); its value is saved in the click and checked as this alias (e.g. x1). A literal alias on the url is ignored.";

// Aliases already taken by another parameter, as its tag or its alias
const getUnavailableAliases = (parameterOptions = [], parameterId) => {
  const otherParams = parameterOptions.filter((param) => param.id !== parameterId);

  return new Set(otherParams.flatMap((param) => [param.tag, param.alias]).filter(Boolean));
};

function AliasSelect({ value, onChange, error, parameterId }) {
  const { trafficData } = useContext(SingleTrafficContext);

  const unavailableAliases = getUnavailableAliases(trafficData?.parameterOptions, parameterId);

  return (
    <TextField
      select
      fullWidth
      name="alias"
      label="Alias"
      value={value ?? ''}
      onChange={onChange}
      SelectProps={{ displayEmpty: true }}
      InputLabelProps={{ shrink: true }}
      error={Boolean(error)}
      helperText={error || HELPER_TEXT}
    >
      <MenuItem value="">None</MenuItem>
      {ALIAS_OPTIONS.map((alias) => (
        <MenuItem key={alias} value={alias} disabled={unavailableAliases.has(alias)}>
          {alias}
        </MenuItem>
      ))}
    </TextField>
  );
}

export default AliasSelect;
